import styled from "styled-components";
const CardDetail = styled.p`
  color: #5a2d91;
`;
export default CardDetail;
